import {
	buildClobEip712Signature,
	buildPolyHmacSignature,
	type ClobSigner,
} from "../signing/index.js";
import { getSignerAddress } from "../signing/signer.js";
import type {
	ApiKeyCreds,
	Chain,
	L1PolyHeader,
	L2HeaderArgs,
	L2PolyHeader,
} from "../types/index.js";

export const createL1Headers = async (
	signer: ClobSigner,
	chainId: Chain,
	nonce?: number,
	timestamp?: number,
	address?: string,
): Promise<L1PolyHeader> => {
	let ts = Math.floor(Date.now() / 1000);
	if (timestamp !== undefined) {
		ts = timestamp;
	}
	let n = 0; // Default nonce is 0
	if (nonce !== undefined) {
		n = nonce;
	}

	const sig = await buildClobEip712Signature(signer, chainId, ts, n, address);
	const resolvedAddress = address ?? (await getSignerAddress(signer));

	const headers = {
		POLY_ADDRESS: resolvedAddress,
		POLY_SIGNATURE: sig,
		POLY_TIMESTAMP: `${ts}`,
		POLY_NONCE: `${n}`,
	};
	return headers;
};

export const createL2Headers = async (
	signer: ClobSigner,
	creds: ApiKeyCreds,
	l2HeaderArgs: L2HeaderArgs,
	timestamp?: number,
): Promise<L2PolyHeader> => {
	let ts = Math.floor(Date.now() / 1000);
	if (timestamp !== undefined) {
		ts = timestamp;
	}
	const address = await getSignerAddress(signer);

	const sig = await buildPolyHmacSignature(
		creds.secret,
		ts,
		l2HeaderArgs.method,
		l2HeaderArgs.requestPath,
		l2HeaderArgs.body,
	);

	const headers = {
		POLY_ADDRESS: address,
		POLY_SIGNATURE: sig,
		POLY_TIMESTAMP: `${ts}`,
		POLY_API_KEY: creds.key,
		POLY_PASSPHRASE: creds.passphrase,
	};

	return headers;
};
